import Vue from 'vue';
import Vuex from 'vuex';
import App from '@/store/modules/app';
import Auth from '@/store/modules/auth';
import User from '@/store/modules/user';
import AuthSubUser from '@/store/modules/authSubUser';
import SpotifyAuth from '@/store/modules/spotifyAuth';
import Playlist from '@/store/modules/playlist';
import SpotifyUser from '@/store/modules/spotifyUser';
import Event from '@/store/modules/event';
import Notifications from '@/store/modules/notifications';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app: App,
    auth: Auth,
    user: User,
    authSubUser: AuthSubUser,
    spotifyAuth: SpotifyAuth,
    playlist: Playlist,
    spotifyUser: SpotifyUser,
    event: Event,
    notifications: Notifications,
  },
});
